import { getFeaturePageLandingQueryOptions } from "@/features/feature-page-landing/feature-page-landing-query";
const SplitLoader = async ({
  context: {
    queryClient,
    locale,
    featurePageFamily
  }
}) => {
  const landing = await queryClient.ensureQueryData(getFeaturePageLandingQueryOptions({
    family: featurePageFamily,
    locale
  }));
  return {
    family: featurePageFamily,
    locale,
    landing
  };
};
export { SplitLoader as loader };